import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ index, label, dark = false }) => (
  <p
    className={`text-xs font-semibold uppercase tracking-[0.28em] ${
      dark ? "text-brand-light" : "text-wealth/50"
    }`}
  >
    {index} — {label}
  </p>
);
